import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import ArrowIcon from '~images/step-arrow.svg'
import ArrowIconBottom from '~images/step-arrow-bottom.svg'
import CheckIcon from '~images/check.svg'

const SetupStepsScreen = () => {
  const steps = [
    {
      title: 'Регистрация',
      text: 'Вы регистрируетесь в сервисе.',
      color: 'rgb(247, 210, 239)'
    },
    {
      title: 'Звонок менеджера',
      text: <span>Наш менеджер свяжется с вами в течение <strong>10 минут</strong> и уточнит потребности.</span>,
      color: 'rgb(175, 227, 243)'
    },
    {
      title: 'Cогласуем время',
      text: 'Вместе с менеджером вы выберете удобное время для настройки АТС.',
      color: 'rgb(213, 216, 255)'
    },
    {
      title: 'Удаленная настройка',
      text: <span>В назначенное время сотрудник техподдержки свяжется с вами, и по удаленному подключению за <strong>20 минут</strong> настроит АТС.</span>,
      color: 'rgb(191, 241, 231)'
    }
  ]

  return (
    <Screen
      title={<span>Не хотите разбираться в настройках телефонии?</span>}
      bottomLine={true}
    >
      <Styled.StepSubTitle>И не нужно — мы сделаем всё за вас. <StyledScreen.GreenText>Бесплатно.</StyledScreen.GreenText></Styled.StepSubTitle>
    </Screen>
  )
}

export { SetupStepsScreen }